// extracted by mini-css-extract-plugin
module.exports = {"aboutMe__markdown":"AboutMe_aboutMe__markdown__2YWQL","aboutMe__content":"AboutMe_aboutMe__content__3U0nm"};